import React, {useCallback, useState} from 'react';
import {makeStyles} from '@material-ui/core';
import {CircularProgress, Icon, Row, Tooltip, Wrapper, Text} from 'components-lib';
import {useEditLearningPath, useLearningPathIdParam} from '../../hooks';
import {
  getDynamicCurrentYearExportLabel,
  getDynamicNextYearExportLabel,
  getDynamicCurrentYearTooltip,
  getDynamicNextYearTooltip,
} from '../../utils';

export const EditLearningPathDetailsHeaderActions = () => {
  const classes = useStyles();
  const {exporting, fetchExportLearningPath, fetchExportLearningPathNextYear} = useEditLearningPath();
  const [exportingType, setExportingType] = useState<null | 'current' | 'next'>(null);
  const {learningPathId} = useLearningPathIdParam();

  const exportClickHandler = useCallback(() => {
    setExportingType('current');
    Promise.resolve(fetchExportLearningPath(learningPathId)).finally(() => setExportingType(null));
  }, [fetchExportLearningPath, learningPathId]);

  const exportNextYearClickHandler = useCallback(() => {
    setExportingType('next');
    Promise.resolve(fetchExportLearningPathNextYear(learningPathId)).finally(() => setExportingType(null));
  }, [fetchExportLearningPathNextYear, learningPathId]);
  return (
    <Row justify="flex-end" classes={{root: classes.container}}>
      <Wrapper className={classes.iconWrapper}>
        <div className={classes.captionText}>
          <Text.Caption>{getDynamicCurrentYearExportLabel()}</Text.Caption>
        </div>
        <Tooltip title={getDynamicCurrentYearTooltip()}>
          <Icon.Button disabled={exporting} clickHandler={exportClickHandler}>
            {exporting && exportingType === 'current' ? (
              <Wrapper className={classes.progress}>
                <CircularProgress size={20} />
              </Wrapper>
            ) : (
              <Icon.ExportXlsOrangeIcon />
            )}
          </Icon.Button>
        </Tooltip>
      </Wrapper>
      <Wrapper className={classes.iconWrapper}>
        <div className={classes.captionText}>
          <Text.Caption>{getDynamicNextYearExportLabel()}</Text.Caption>
        </div>
        <Tooltip title={getDynamicNextYearTooltip()}>
          <Icon.Button disabled={exporting} clickHandler={exportNextYearClickHandler}>
            {exporting && exportingType === 'next' ? (
              <Wrapper className={classes.progress}>
                <CircularProgress size={20} />
              </Wrapper>
            ) : (
              <Icon.ExportXlsGreenIcon />
            )}
          </Icon.Button>
        </Tooltip>
      </Wrapper>
    </Row>
  );
};

const useStyles = makeStyles((theme) => ({
  progress: {
    padding: theme.spacing(0, 1),
  },
  container: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    flexWrap: 'nowrap',
    gap: theme.spacing(2),
    minHeight: '60px',
  },
  iconWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: '60px',
    maxWidth: '80px',
    textAlign: 'center',
    margin: theme.spacing(0, 0.5),
  },
  captionText: {
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    lineHeight: 1.3,
    marginBottom: theme.spacing(0.5),
    fontSize: '0.75rem',
    hyphens: 'auto',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));
